export default {
  userCustomFields: state => state.userCustomFields,
  isAuthenticated: state => !!state.auth_greennCourse,
  currentAuth: state => state.auth_greennCourse || null,
  authStatus: state => state.status,
  authErrors: state => state.errors,
  getEmail: state => state.email,
  getDocument: state => state.document,
  getPassword: state => state.password,
  getConfirmPassword: state => state.confirmPassword,
  getButtonIsDisabled: state => state.buttonIsDisabled,
  getFreeCourses: state => state.freeCourses,
  getLogo: state => state.logo,
  getColor: state => state.color,
  getBackgroundImage: state => state.backgroundImage,
  getUrlBackground: state => state.urlBackground,
  getThemeFixedPanel: state => state.themeFixedPanel,
}